import { MultiSelect } from "@/components/atoms";
import type { ProductSelectorProps } from "./types";

export function ProductSelector({ selectedIds, products, onChange, isLoading, required }: ProductSelectorProps) {
    return (
        <MultiSelect
            label="Products"
            options={products.map((product) => ({
                id: product.id,
                label: product.name,
            }))}
            selectedIds={selectedIds}
            onChange={onChange}
            placeholder="Select one or more products"
            emptyMessage="No products available"
            isLoading={isLoading}
            required={required}
            searchable
        />
    );
}
